exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.rate-options[data-v-09bcb31b] {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n.rate-option[data-v-09bcb31b] {\n  border: 1px solid #29bf121a;\n  border-radius: 4px;\n  padding: 1rem;\n  cursor: pointer;\n  transition: #29bf12 0.3s, border-color 0.3s;\n}\n.rate-option[data-v-09bcb31b]:hover {\n  border-color: #29bf12;\n}\n.rate-option.selected[data-v-09bcb31b] {\n  background-color: #29bf12;\n  border-color: #29bf12;\n  color: #fff !important;\n}\n.rate-option.selected h4[data-v-09bcb31b] {\n  color: #fff !important;\n}\n", ""]);

// exports
